module.exports = __webpack_public_path__ + "img/best-workplace.d0522038.png";